import { EMPTY_ERROR, FETCH_OTP_REQUEST, GET_OTP, OTP_FAILURE, SUBMIT_OTP } from '../actions/types';

const initialState = {
    loading: false,
    otpData: null,
    submitData: null,
    error: null
};

const otpVerficationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_OTP_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_OTP:
            return { ...state, loading: false, otpData: action.payload, error: null };
        case SUBMIT_OTP:
            return { ...state, loading: false, submitData: action.payload, error: null };
        case OTP_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case EMPTY_ERROR:
            return { ...state, loading: false, error: null };
        default:
            return state;
    }
};

export default otpVerficationReducer;